import type { FC } from 'react';

import { IconButtonWithTooltip, Icons, TooltipPositions } from '../../../controls/iconButton/IconButtonWithTooltip';

interface LiveSupportControlPlainProps {
  condition: boolean;
  onClick: () => void;
  showBadge: boolean;
}

export const LiveSupportControlPlain: FC<LiveSupportControlPlainProps> = ({ condition, onClick, showBadge }) => {
  return (
    <IconButtonWithTooltip
      data-testid="live-support-button"
      icon={Icons.Support}
      active={condition}
      onClick={onClick}
      badge={showBadge}
      tooltipOptions={{
        text: 'LIVE_SUPPORT',
        position: TooltipPositions.Bottom,
      }}
    />
  );
};
